// Custom SVG icons — all sized to 28x28 by default, stroke-based, theme-aware
// Color: var(--green) strokes on transparent fill

export const BatteryIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="7" width="22" height="14" rx="2" stroke={color} strokeWidth="1.5"/>
      <path d="M24 11v6" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <path d="M9 14h10M14 9v10" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  );
  
  export const GearIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="14" cy="14" r="3.5" stroke={color} strokeWidth="1.5"/>
      <path d="M14 3v3M14 22v3M3 14h3M22 14h3M6.22 6.22l2.12 2.12M19.66 19.66l2.12 2.12M6.22 21.78l2.12-2.12M19.66 8.34l2.12-2.12" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
  
  export const AtomIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="14" cy="14" r="2" fill={color}/>
      <ellipse cx="14" cy="14" rx="10" ry="4.5" stroke={color} strokeWidth="1.4"/>
      <ellipse cx="14" cy="14" rx="10" ry="4.5" stroke={color} strokeWidth="1.4" transform="rotate(60 14 14)"/>
      <ellipse cx="14" cy="14" rx="10" ry="4.5" stroke={color} strokeWidth="1.4" transform="rotate(120 14 14)"/>
    </svg>
  );
  
  export const CycleIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 14A9 9 0 0114 5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M23 14A9 9 0 0114 23" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M14 5l-2.5 2.5L14 10" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14 23l2.5-2.5L14 18" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
  
  export const TruckIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="8" width="16" height="12" rx="1.5" stroke={color} strokeWidth="1.5"/>
      <path d="M18 12h4l3 4v4h-7V12z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
      <circle cx="7" cy="21" r="2" stroke={color} strokeWidth="1.4"/>
      <circle cx="21" cy="21" r="2" stroke={color} strokeWidth="1.4"/>
    </svg>
  );
  
  export const BoltIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 3L8 16h7l-3 9 11-13h-7l3-9z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  );
  
  export const WrenchIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 4a5 5 0 00-6.9 6.9L4 20a1.41 1.41 0 002 2l9.1-9.1A5 5 0 0020 4z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
      <circle cx="7" cy="21" r="1" fill={color}/>
    </svg>
  );
  
  export const CrystalIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 3l5 7H9l5-7z" stroke={color} strokeWidth="1.4" strokeLinejoin="round"/>
      <path d="M9 10l5 15 5-15H9z" stroke={color} strokeWidth="1.4" strokeLinejoin="round"/>
      <path d="M9 10H4l5 7M19 10h5l-5 7" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
  
  export const ChainIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 17l6-6" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <rect x="3" y="15" width="8" height="5" rx="2.5" stroke={color} strokeWidth="1.4" transform="rotate(-45 3 15)"/>
      <rect x="17" y="8" width="8" height="5" rx="2.5" stroke={color} strokeWidth="1.4" transform="rotate(-45 17 8)"/>
    </svg>
  );
  
  export const ScaleIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 4v20M6 24h16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M14 4L6 8l-2 6a6 6 0 0012 0L14 8z" stroke={color} strokeWidth="1.4" strokeLinejoin="round"/>
      <path d="M14 4l8 4 2 6a6 6 0 01-12 0l2-6z" stroke={color} strokeWidth="1.4" strokeLinejoin="round"/>
    </svg>
  );
  
  export const ShieldIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 3l9 4v6c0 5.5-3.8 10.6-9 12C9.8 23.6 6 18.5 6 13V7l8-4z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M10 14l3 3 5-5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
  
  export const TrophyIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 3h10v9a5 5 0 01-10 0V3z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M9 7H5a2 2 0 000 4h4M19 7h4a2 2 0 010 4h-4" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
      <path d="M14 17v5M10 22h8" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  );
  
  export const CarIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 17l2-6h14l2 6" stroke={color} strokeWidth="1.4" strokeLinejoin="round"/>
      <rect x="3" y="17" width="22" height="6" rx="1.5" stroke={color} strokeWidth="1.4"/>
      <circle cx="8" cy="23" r="2" stroke={color} strokeWidth="1.3"/>
      <circle cx="20" cy="23" r="2" stroke={color} strokeWidth="1.3"/>
      <path d="M9 11l2-3h6l2 3" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
  
  export const FactoryIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 24V12l6 4V12l6 4V8h4v16H3z" stroke={color} strokeWidth="1.4" strokeLinejoin="round"/>
      <path d="M19 8V4M23 8V4" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
      <rect x="6" y="18" width="3" height="4" stroke={color} strokeWidth="1.2"/>
      <rect x="12" y="18" width="3" height="4" stroke={color} strokeWidth="1.2"/>
    </svg>
  );
  
  export const LaptopIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="5" width="20" height="14" rx="1.5" stroke={color} strokeWidth="1.4"/>
      <path d="M2 19h24" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
      <path d="M10 22h8" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  );
  
  export const BoxIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 9l11-5 11 5v10l-11 5L3 19V9z" stroke={color} strokeWidth="1.4" strokeLinejoin="round"/>
      <path d="M14 4v20M3 9l11 5 11-5" stroke={color} strokeWidth="1.3" strokeLinecap="round"/>
    </svg>
  );
  
  export const TowerIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6" y="12" width="6" height="12" stroke={color} strokeWidth="1.4"/>
      <rect x="16" y="8" width="6" height="16" stroke={color} strokeWidth="1.4"/>
      <path d="M4 24h20" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
      <path d="M9 12V8l3-4 3 4v4" stroke={color} strokeWidth="1.3" strokeLinejoin="round"/>
    </svg>
  );
  
  export const ChartIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 20l6-8 5 4 5-10 4 4" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4 24h20M4 4v20" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  );
  
  export const HandshakeIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 10l4 4 3-2 4 4 3-2 4 4 4-4" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7 14l-4 6M21 14l4 6" stroke={color} strokeWidth="1.3" strokeLinecap="round"/>
    </svg>
  );
  
  export const PillarIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="5" width="22" height="3" rx="1" stroke={color} strokeWidth="1.4"/>
      <rect x="3" y="20" width="22" height="3" rx="1" stroke={color} strokeWidth="1.4"/>
      <path d="M8 8v12M14 8v12M20 8v12" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  );
  
  export const WasteIcon = ({ size = 28, color = "var(--amber)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 3v10M10 7l4-4 4 4" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5 13h18l-2 12H7L5 13z" stroke={color} strokeWidth="1.4" strokeLinejoin="round"/>
      <path d="M11 17v4M17 17v4" stroke={color} strokeWidth="1.3" strokeLinecap="round"/>
    </svg>
  );
  
  export const ImportIcon = ({ size = 28, color = "var(--amber)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="14" cy="14" r="10" stroke={color} strokeWidth="1.4"/>
      <path d="M4 14h20M14 4c-2.5 3-4 6.5-4 10s1.5 7 4 10M14 4c2.5 3 4 6.5 4 10s-1.5 7-4 10" stroke={color} strokeWidth="1.3" strokeLinecap="round"/>
      <path d="M10 10l4 4 4-4" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
  
  export const HazardIcon = ({ size = 28, color = "var(--amber)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 3L2 24h24L14 3z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M14 11v6M14 20v1" stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  );
  
  export const LocationIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 3a8 8 0 018 8c0 5-8 14-8 14S6 16 6 11a8 8 0 018-8z" stroke={color} strokeWidth="1.5"/>
      <circle cx="14" cy="11" r="3" stroke={color} strokeWidth="1.4"/>
    </svg>
  );
  
  export const MailIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="7" width="22" height="14" rx="1.5" stroke={color} strokeWidth="1.4"/>
      <path d="M3 8l11 8 11-8" stroke={color} strokeWidth="1.3" strokeLinecap="round"/>
    </svg>
  );
  
  export const PhoneIcon = ({ size = 28, color = "var(--green)" }) => (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 4h6l2 5-3 2a14 14 0 006 6l2-3 5 2v6a2 2 0 01-2 2C9 24 4 12 4 6a2 2 0 012-2z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  );